// The explicit seam where the future Unity/WebGL 3D placement editor mounts.
// ATTACHMENT-SYSTEM-DESIGN.md Phase 2 promises a real 3D placement affordance;
// until it exists, this chip marks the spot so the intent is visible in the UI
// and the mount point is obvious in code: replace <UnityEditorSeam /> (and the
// placeholder HookViewport around it) with the Unity editor component.

export function UnityEditorSeam() {
  return (
    <div className="hke-seam" title="The interactive 3D placement editor is a planned Unity/WebGL component. It will mount exactly here, replacing the placeholder viewport.">
      <span className="hke-seam__dot" aria-hidden="true" />
      3D placement editor (Unity) — planned; numeric editing available in the inspector
    </div>
  );
}

export default UnityEditorSeam;
